export default __webpack_public_path__ + "static/media/DelhiLineUp.27be28fd.svg";